module.exports = __webpack_public_path__ + "img/phone-screen-es.617bf199.png";